import routeEnpoints from 'route/endpoints';

import { ReactComponent as AlertIcon } from 'asset/IconsPack/at_alert-circle-filled.svg';
import { ReactComponent as FilterIcon } from 'asset/IconsPack/at_filter-funnel-02.svg';
import { ReactComponent as SearchIcon } from 'asset/IconsPack/at_search-sm-filled.svg';
import webhookLogsPoster from 'asset/img/announcements/webhook-delivery-logs-poster.jpg';

// Newest first. Give each launch a new id so admins who saw the last one still get it.
export const ANNOUNCEMENTS = [
    {
        id: 'webhook-delivery-logs-launch',
        media: {
            // A muted loop from the CDN, so the clip stays out of the app bundle.
            type: 'video',
            src: 'https://cdn.authenticating.com/public/portal/video-guides/webhook-delivery-logs.mp4',
            poster: webhookLogsPoster,
            alt: 'Opening Webhook Delivery Logs from Credentials, searching a user access code, then opening a failed delivery to see why it failed',
        },
        title: 'Introducing Webhook Delivery Logs',
        subtitle: 'Every webhook, every attempt, in one place',
        description:
            'See every webhook we sent to your URLs, find a delivery by event ID or user access code, and open any failure to see what went wrong.',
        highlights: [
            { icon: SearchIcon, label: 'Search by event or user' },
            { icon: FilterIcon, label: 'Filter by status and date' },
            { icon: AlertIcon, label: 'Fix hints for failures' },
        ],
        // Opens the logs drawer straight away on the Credentials tab.
        primaryAction: {
            label: 'View Delivery Logs',
            to: `${routeEnpoints.settings}?logs=1#credentials`,
        },
        secondaryLabel: 'Maybe later',
    },
];
